// Frontend mirror of backend/src/utils/sectionProfiles.js
// Used only for display — detection must match backend logic exactly.

export const PROFILES = {
  introduction: {
    id:                  'introduction',
    label:               'Introduction',
    writingMode:         'orienting',
    analyticalIntensity:       0.50,
    abstractionLevel:          0.50,
    critiqueIntensity:         0.20,
    noiseIntensity:            0.40,
    optimizationLevel:         0.50,
    evidenceConsistency:       0.65,
    hypothesisSupportStrength: 0.60,
    dataVariability:           0.30,
    interpretiveAmbiguity:     0.45,
    citationDensityLevel:      0.35,
    citationDensityLabel:      'low-moderate',
    color:               '#0284c7',
  },
  literature_review: {
    id:                  'literature_review',
    label:               'Literature Review',
    writingMode:         'analytical-critical',
    analyticalIntensity:       0.95,
    abstractionLevel:          0.80,
    critiqueIntensity:         0.85,
    noiseIntensity:            0.75,
    optimizationLevel:         0.70,
    evidenceConsistency:       0.45,
    hypothesisSupportStrength: 0.50,
    dataVariability:           0.55,
    interpretiveAmbiguity:     0.70,
    citationDensityLevel:      0.90,
    citationDensityLabel:      'dense',
    color:               '#7c3aed',
  },
  methodology: {
    id:                  'methodology',
    label:               'Methodology',
    writingMode:         'procedural',
    analyticalIntensity:       0.40,
    abstractionLevel:          0.35,
    critiqueIntensity:         0.30,
    noiseIntensity:            0.20,
    optimizationLevel:         0.55,
    evidenceConsistency:       0.60,
    hypothesisSupportStrength: 0.55,
    dataVariability:           0.40,
    interpretiveAmbiguity:     0.30,
    citationDensityLevel:      0.45,
    citationDensityLabel:      'focused',
    color:               '#059669',
  },
  findings: {
    id:                  'findings',
    label:               'Findings / Results',
    writingMode:         'descriptive',
    analyticalIntensity:       0.30,
    abstractionLevel:          0.25,
    critiqueIntensity:         0.10,
    noiseIntensity:            0.25,
    optimizationLevel:         0.45,
    evidenceConsistency:       0.40,
    hypothesisSupportStrength: 0.50,
    dataVariability:           0.75,
    interpretiveAmbiguity:     0.50,
    citationDensityLevel:      0.20,
    citationDensityLabel:      'sparse',
    color:               '#d97706',
  },
  discussion: {
    id:                  'discussion',
    label:               'Discussion',
    writingMode:         'interpretive-synthetic',
    analyticalIntensity:       0.90,
    abstractionLevel:          0.75,
    critiqueIntensity:         0.70,
    noiseIntensity:            0.80,
    optimizationLevel:         0.75,
    evidenceConsistency:       0.45,
    hypothesisSupportStrength: 0.55,
    dataVariability:           0.65,
    interpretiveAmbiguity:     0.75,
    citationDensityLevel:      0.70,
    citationDensityLabel:      'selective',
    color:               '#7c3aed',
  },
  conclusion: {
    id:                  'conclusion',
    label:               'Conclusion',
    writingMode:         'consolidating',
    analyticalIntensity:       0.60,
    abstractionLevel:          0.55,
    critiqueIntensity:         0.40,
    noiseIntensity:            0.35,
    optimizationLevel:         0.60,
    evidenceConsistency:       0.55,
    hypothesisSupportStrength: 0.60,
    dataVariability:           0.40,
    interpretiveAmbiguity:     0.50,
    citationDensityLevel:      0.15,
    citationDensityLabel:      'minimal',
    color:               '#0284c7',
  },
  limitations: {
    id:                  'limitations',
    label:               'Limitations',
    writingMode:         'reflective-cautious',
    analyticalIntensity:       0.40,
    abstractionLevel:          0.40,
    critiqueIntensity:         0.50,
    noiseIntensity:            0.45,
    optimizationLevel:         0.40,
    evidenceConsistency:       0.40,
    hypothesisSupportStrength: 0.40,
    dataVariability:           0.70,
    interpretiveAmbiguity:     0.65,
    citationDensityLevel:      0.20,
    citationDensityLabel:      'sparse',
    color:               '#ea580c',
  },
  appendix: {
    id:                  'appendix',
    label:               'Appendix',
    writingMode:         'mechanical',
    analyticalIntensity:       0.10,
    abstractionLevel:          0.10,
    critiqueIntensity:         0.00,
    noiseIntensity:            0.05,
    optimizationLevel:         0.25,
    evidenceConsistency:       0.80,
    hypothesisSupportStrength: 0.50,
    dataVariability:           0.20,
    interpretiveAmbiguity:     0.10,
    citationDensityLevel:      0.05,
    citationDensityLabel:      'minimal',
    color:               '#64748b',
  },
}

const DEFAULT_PROFILE = PROFILES.literature_review

export function detectProfile(chapterTitle, chapterNumber) {
  const t = (chapterTitle || '').toLowerCase()

  if (/\bintroduc/.test(t))                                                              return PROFILES.introduction
  if (/lit(erature)?\s+review|theoretical\s+frame|conceptual\s+frame|theoretical\s+background/.test(t))
                                                                                         return PROFILES.literature_review
  if (/methodolog|research\s+design|data\s+collect|research\s+approach/.test(t))        return PROFILES.methodology
  if (/\bfinding|result/.test(t))                                                        return PROFILES.findings
  if (/\bdiscussion|analys/.test(t))                                                     return PROFILES.discussion
  if (/conclusion|implication|contribution|recommendation/.test(t))                     return PROFILES.conclusion
  if (/limitation/.test(t))                                                              return PROFILES.limitations
  if (/appendix|appendic/.test(t))                                                       return PROFILES.appendix

  if (chapterNumber === 1) return PROFILES.introduction

  return DEFAULT_PROFILE
}
